import { render, staticRenderFns } from "./TransactionAmount.vue?vue&type=template&id=0b4c09d0&"
import script from "./TransactionAmount.vue?vue&type=script&lang=js&"
export * from "./TransactionAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports